(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  // lazysizes replacement — critical, runs immediately
  function upgradeLazyImages(root) {
    (root || document).querySelectorAll('img.lazyload[data-src]').forEach(function (img) {
      var tpl = img.getAttribute('data-src');
      var widths;
      try { widths = JSON.parse(img.getAttribute('data-widths') || '[]'); }
      catch (e) { widths = []; }

      if (tpl && tpl.indexOf('{width}') > -1 && widths.length) {
        img.srcset = widths.map(function (w) {
          return tpl.replace('{width}', w) + ' ' + w + 'w';
        }).join(', ');
        if (!img.getAttribute('sizes')) img.sizes = 'auto';
      }
      if (!img.getAttribute('loading')) img.loading = 'lazy';
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
      img.removeAttribute('data-src');
      img.removeAttribute('data-widths');
      img.removeAttribute('data-sizes');
      img.removeAttribute('data-aspectratio');
    });

    (root || document).querySelectorAll('.lazyload:not(img)').forEach(function (el) {
      el.classList.remove('lazyload');
      el.classList.add('lazyloaded');
    });
  }

  // AOS replacement — runs only when [data-aos] elements exist
  function initAnimations() {
    var els = document.querySelectorAll('[data-aos]:not([data-aos=""])');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('aos-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-aos-delay'), 10) || 0;
        setTimeout(function () { el.classList.add('aos-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -30px 0px', threshold: 0.01 });

    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('aos-in');
        return;
      }
      el.classList.add('aos-init');
      io.observe(el);
    });
  }

  // Cookie banner — runs only when .js-cookie-policy exists
  function initCookieBanner() {
    document.querySelectorAll('.js-cookie-policy').forEach(function (banner) {
      var hide = function () {
        banner.style.opacity = '0';
        setTimeout(function () { banner.style.display = 'none'; }, 400);
      };
      var show = function () {
        banner.style.display = '';
        banner.style.transition = 'opacity .4s';
        requestAnimationFrame(function () { banner.style.opacity = '1'; });
      };

      if (localStorage.getItem('localCookie')) {
        banner.style.display = 'none';
      } else {
        banner.style.opacity = '0';
        show();
      }

      var ok = banner.querySelector('.js-btn-ok');
      var no = banner.querySelector('.js-btn-decline');
      if (ok) ok.addEventListener('click', function () {
        try { localStorage.setItem('localCookie', 'accept'); } catch (e) {}
        hide();
      });
      if (no) no.addEventListener('click', hide);
    });
  }

  // Track123 tracking form — inject input placeholders.
  // The widget is a web component that renders its own inputs asynchronously
  // and ships without placeholder text, so we can't set it in CSS or Liquid:
  // we wait for the inputs, map them by their label, and set .placeholder.
  var TRACK123_PLACEHOLDERS = {
    'order number': 'e.g. #1043',
    'email or phone number': 'you@example.com',
    'tracking number': 'e.g. AB123456789GB'
  };

  function applyTrack123Placeholders() {
    var rows = document.querySelectorAll('track123-search-artsy .track123-input-content');
    if (!rows.length) return false;
    rows.forEach(function (row) {
      var lblEl = row.querySelector('.track123-input-label');
      var input = row.querySelector('input.track123-input');
      if (!input || !lblEl) return;
      var key = lblEl.textContent.trim().toLowerCase();
      if (TRACK123_PLACEHOLDERS[key] && !input.placeholder) {
        input.placeholder = TRACK123_PLACEHOLDERS[key];
      }
    });
    return true;
  }

  function initTrack123Placeholders() {
    var host = document.querySelector('track123-search-artsy');
    if (!host || host.dataset.phInit === '1') return; // avoid stacking observers
    host.dataset.phInit = '1';

    applyTrack123Placeholders();

    // widget loads its own module async — retry until the inputs exist
    var tries = 0;
    var timer = setInterval(function () {
      if (applyTrack123Placeholders() || ++tries > 40) clearInterval(timer);
    }, 250);

    // re-apply when the widget re-renders (e.g. going back from detail view)
    if ('MutationObserver' in window) {
      new MutationObserver(applyTrack123Placeholders)
        .observe(host, { childList: true, subtree: true });
    }
  }

  // Bootstrap
  upgradeLazyImages();

  ready(function () {
    initAnimations();
    initCookieBanner();
    initTrack123Placeholders();
  });

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    upgradeLazyImages(e.target);
    initAnimations();
    initCookieBanner();
    initTrack123Placeholders();
  });
})();